import { TextInput } from "artisn-ui-react";
import React from "react";

import Styles from "./RedeemCouponInput.styles";
import { RedeemCouponInputProps as Props } from "./RedeemCouponInput.types";
import Button from "components/global/Button/Button";
import useI18n from "hooks/useI18n";

const RedeemCouponInput: React.FC<Props> = props => {
  const { className, disabled, couponCode, onRedeem, setCouponCode } = props;
  const { showLabel = true, buttonText = "" } = props;
  const t = useI18n();
  const label = showLabel ? t.coupons.addCoupon : "";

  return (
    <Styles
      disabled={disabled ?? true}
      className={`RedeemCouponInput ${className}`}
    >
      <TextInput
        className="RedeemCouponInput__text-input field"
        label={label}
        name="redeem"
        disabled={disabled}
        value={couponCode}
        onChange={e => setCouponCode(e.target.value.trim())}
        maxLength={50}
      />
      <Button
        className="RedeemCouponInput__input-button"
        type="BORDER"
        color="primary"
        disabled={disabled}
        onClick={() => onRedeem(couponCode)}
      >
        {buttonText ? buttonText : t.coupons.apply}
      </Button>
    </Styles>
  );
};

RedeemCouponInput.defaultProps = {
  className: ""
};

export default RedeemCouponInput;
